export class WinningReson {
    WinningReasonsID : number;
    WinningReasonsName : string;
    WinningReasonsDescription : string;
    IsActive : boolean = true;
    ModifiedBy : number;
}